import { BaseTable, Card, Sizes, Spacings } from '@sede-enterprise/shell-ds-react-framework';
import styled from 'styled-components';
import { KPI_SUMMARY } from '../../../../../api/constants';
import { three } from '../../../../../constants';
import { IGroupNCI, TKpiSummaryCol, IDealDetails, IKpiModal } from '../../../../../types/types';
import { getColorByValue, getImpactNciDataForTwoYears } from '../../DealDetailFunctions';

const StyledBaseTable = styled(BaseTable)<{
  rowColor: { rowColorForFirstRow: string; rowColorForSecondRow: string };
}>`
  tbody tr:nth-child(3) td {
    border-bottom: 1px solid #e0e0e0;
  }
  tbody tr:nth-child(4) td {
    color: ${(props) => props.rowColor.rowColorForFirstRow};
    font-weight: bold;
    font-size: 14px;
  }
  tbody tr:nth-child(5) td {
    color: ${(props) => props.rowColor.rowColorForSecondRow};
    font-weight: bold;
    font-size: 14px;
  }
`;

const SummaryTable = (props: {
  maxEquityScope: TKpiSummaryCol;
  maxNetAbsoluteEmission: TKpiSummaryCol;
  maxMCR: TKpiSummaryCol;
  netCarbonIntensityData: IGroupNCI[];
  dealDetailsData: IDealDetails[];
  kpiTableData: IKpiModal[];
}) => {
  const { maxEquityScope, maxNetAbsoluteEmission, maxMCR, netCarbonIntensityData, dealDetailsData, kpiTableData } = props;
  const {
    nciValueForFirstRow,
    nciValueForSecondRow,
    nciForFirstRowUnit,
    nciForSecondRowUnit,
    firstRowYear,
    secondRowYear,
  } = netCarbonIntensityData && getImpactNciDataForTwoYears(netCarbonIntensityData, dealDetailsData, kpiTableData);
  const rowColorForFirstRow = getColorByValue(Number(nciValueForFirstRow));
  const rowColorForSecondRow = getColorByValue(Number(nciValueForSecondRow));
  const cardTableData = [
    {
      KPIs: 'Equity Scope 1&2 Carbon (Peak annual emissions)',
      Value: (maxEquityScope?.value ?? 0).toFixed(three),
      Unit: maxEquityScope?.unit,
    },
    {
      KPIs: 'Net Absolute Emissions Scope 1,2 & 3 (Peak annual emissions)',
      Value: (maxNetAbsoluteEmission?.value ?? 0).toFixed(three),
      Unit: maxNetAbsoluteEmission?.unit,
    },
    {
      KPIs: 'Margin to Carbon Ratio (Average)',
      Value: (maxMCR?.value ?? 0).toFixed(three),
      Unit: maxMCR?.unit,
    },
    ...(firstRowYear
      ? [
          {
            KPIs: `NCI Impact in ${firstRowYear}`,
            Value: nciValueForFirstRow,
            Unit: nciForFirstRowUnit,
          },
        ]
      : []),
    {
      KPIs: `NCI Impact in ${secondRowYear}`,
      Value: nciValueForSecondRow,
      Unit: nciForSecondRowUnit,
    },
  ];
  const cols = [
    {
      accessorKey: 'KPIs',
      header: 'KPIs',
    },
    {
      accessorKey: 'Value',
      header: 'Value',
    },
    {
      accessorKey: 'Unit',
      header: 'Unit',
    },
  ];

  return (
    <Card
      size={Sizes.Small}
      bodyPadding={true}
      header={{
        title: KPI_SUMMARY,
      }}
      className='kpiCardMaxWidth'
      padding={Spacings.Tight}
    >
      <StyledBaseTable
        className='custom-table'
        style={{ width: '100%' }}
        size='small'
        noFooter
        maxHeight={1000}
        columns={cols}
        data={cardTableData}
        rowColor={{ rowColorForFirstRow, rowColorForSecondRow }}
      />
    </Card>
  );
};

export default SummaryTable;
